export interface IBroadcastChannelMessage<T> {
  channelName: string;
  type: string;
  payload: T;
}
export enum BroadcastChannelDefault {
  APP = 'Application_Broadcast_Channel',
}
